(() => {
  const collapsedHeight = 240;

  const setup = () => {
    document.querySelectorAll('.collection-description-wrap').forEach((wrap) => {
      const description = wrap.querySelector('.collection-description');
      const button = wrap.querySelector('.read-more-btn');
      if (!description || !button) return;

      description.classList.remove('is-collapsed', 'expanded');
      button.style.display = 'none';
      button.textContent = 'Read More';

      if (description.scrollHeight > collapsedHeight) {
        description.classList.add('is-collapsed');
        button.style.display = 'inline-block';
      }
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.collection-description-wrap .read-more-btn');
    if (!button) return;

    const wrap = button.closest('.collection-description-wrap');
    const description = wrap && wrap.querySelector('.collection-description');
    if (!description) return;

    if (description.classList.contains('is-collapsed')) {
      description.classList.remove('is-collapsed');
      description.classList.add('expanded');
      button.textContent = 'Read Less';
    } else {
      description.classList.remove('expanded');
      description.classList.add('is-collapsed');
      button.textContent = 'Read More';
    }
  });

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  window.addEventListener('resize', setup);
})();
